<div #scrollContainer class="min-h-[calc(100vh-180px)] max-h-[calc(100vh-180px)] overflow-y-auto mt-2">
  <ol class="relative border-s ms-4 border-gray-200 @container">
    @for (audit of decoratedAuditLogs; track $index) {
      <li class="mb-10 ms-6">
        <span
          class="absolute flex items-center justify-center w-6 h-6 bg-amber-100 rounded-full -start-3 ring-8 ring-white"
        >
          <svg
            class="w-2.5 h-2.5 text-amazone-orange"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            viewBox="0 0 20 20"
          >
            <path
              d="M20 4a2 2 0 0 0-2-2h-2V1a1 1 0 0 0-2 0v1h-3V1a1 1 0 0 0-2 0v1H6V1a1 1 0 0 0-2 0v1H2a2 2 0 0 0-2 2v2h20V4ZM0 18a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8H0v10Zm5-8h10a1 1 0 0 1 0 2H5a1 1 0 0 1 0-2Z"
            />
          </svg>
        </span>
        <h3 class="mb-1 font-semibold text-gray-900">
          {{ audit?.action }} {{ languageInfoStringForTranslation(audit) }}
        </h3>
        <time class="block mb-2 text-sm font-normal leading-none text-amazone-orange"
          >{{ audit?.timestamp }} • {{ audit?.username }}</time
        >
        @if (!audit.changes) {
          <p class="text-sm text-gray-500 whitespace-pre-line break-words w-full">
            {{ audit?.changedProperties }}
          </p>
        } @else {
          <app-changes-table [changes]="audit.changes"></app-changes-table>
        }
      </li>
    } @empty {
      <li class="mb-10 ms-6 mt-20">
        <h4 class="mb-1 text-center font-semibold text-gray-700">No audit logs found</h4>
      </li>
    }
  </ol>
</div>
